import { PlatformClient } from "../PlatformClient";
import { Department } from "./departments";

export interface UserListItem {
    id: string;
    name: string;
    email: string;
}

export function createUserApi(client: PlatformClient) {
    return {
        guardianDepartments(userID: string) {
            return client.get<Department[]>(`api/users/${userID}/guardian-departments`);
        },
        list(accessLevel: string, search?: string, excludeIDs?: string[]) {
            return client.get<UserListItem[]>("api/users", {
                accessLevel,
                search,
                excludeIDs: excludeIDs?.length ? excludeIDs.join(",") : undefined,
            });
        },
    };
}

export type UserApi = ReturnType<typeof createUserApi>;
